import React from 'react'
import styled from 'styled-components'
import {
  BRANCH_CAMERAS,
  BRANCH_CHEMICALS,
  BRANCH_INSTITUTIONS,
  BRANCH_SUPPLIER,
} from '../../constants'
import { Label, H6, TextSmall } from '../TextPrimitives'
import { transparentUI } from '../../style-functions'
import Anime from '../Animation/Anime'
import { fadeOut } from '../Animation/Animations'
import markerSizes from './marker-sizes.svg'

const Wrapper = styled.div`
  position: relative;
  width: 24rem;
  height: 43rem;
  color: ${({ theme }) => theme.colors.text.inverse};
`
const Background = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  border-radius: 0.5rem;
  ${transparentUI}
`
const Content = styled.div`
  position: relative;
  padding: 4rem 3rem;
`

const SectionWithBorder = styled.div`
  :not(:last-child) {
    margin-bottom: 4rem;
  }
`

const Heading = styled(H6)`
  margin-bottom: 2rem;
`

const Description = styled(TextSmall)`
  margin-top: 4rem;
`

const SVG = styled.img.attrs({ src: markerSizes })`
  position: absolute;
  top: 1.4rem;
`

const Branch = styled(Label)`
  position: relative;
  padding-left: 2.25rem;

  :before {
    content: '';
    display: block;
    position: absolute;
    top: 0.2rem;
    left: 0;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 1.25rem;
    background: ${({ theme, branch }) => theme.colors.branch[branch]};
  }

  :not(:last-child) {
    margin-bottom: 1rem;
  }
`

const SizesContainer = styled.div`
  position: relative;
`

const Size = styled(Label)`
  position: relative;
  top: ${({ offset }) => offset}rem;
`

const Section = ({ name = 'Name', description, children }) => (
  <SectionWithBorder>
    <Heading>{name}</Heading>
    {children}
    {description && <Description>{description}</Description>}
  </SectionWithBorder>
)

/**
 * Legend component that explains circle sizes and color meaning of the map.
 */
const Legend = ({ show }) => (
  <Anime in={show} exit={fadeOut({ duration: 300 })}>
    <Wrapper>
      <Background>
        <Content>
          <Section
            name="Betriebsgröße"
            description="in Relation zu den Betriebsgrößen der jeweiligen Epoche"
          >
            <SizesContainer>
              <Size offset={0}>Großbetrieb</Size>
              <Size offset={1.3}>Mittelstand</Size>
              <Size offset={1.6}>Kleinbetrieb</Size>
              <SVG />
            </SizesContainer>
          </Section>
          <Section name="Branchen">
            <Branch branch={BRANCH_CHEMICALS}>Fotochemie</Branch>
            <Branch branch={BRANCH_CAMERAS}>Kameraindustrie</Branch>
            <Branch branch={BRANCH_SUPPLIER}>Zubehör</Branch>
            <Branch branch={BRANCH_INSTITUTIONS}>Institutionen</Branch>
          </Section>
        </Content>
      </Background>
    </Wrapper>
  </Anime>
)

export default Legend
